<template>
    <v-dialog width="430" v-model="isOpenEditDialog">
        <v-card class="mx-auto" elevation="0">
            <v-card-title
                class="text-h6 font-weight-regular justify-space-between"
            >
                <h3 class="font-weight-light primary--text">
                    {{
                        installmentFormType != 'EDIT'
                            ? 'Creando Installment'
                            : 'Editando Installment'
                    }}
                </h3>
                <v-switch
                    v-if="installmentFormType!='OFFER_CONFIGURATOR'"
                    inset
                    :label="
                        editingInstallment.is_active ? 'Activo' : 'Inactivo'
                    "
                    v-model="editingInstallment.is_active"
                    :color="editingInstallment.is_active ? 'green' : 'red'"
                ></v-switch>
            </v-card-title>
            <v-card elevation="0" class="pa-4">
                <v-row no-gutters>
                    <v-col md="4">
                        <v-card outlined elevation="0">
                            <h4 class="font-weight-light primary--text px-2">Precio Inicial</h4>
                            <v-divider class="mx-2"></v-divider>
                            <v-text-field
                                type="number"
                                dense
                                placeholder="0"
                                :error-messages="editingInstallment.initial_price < 0 ? 'Valor no válido' : ''"
                                v-model="editingInstallment.initial_price"
                                class="px-2 pt-4"
                            ></v-text-field>
                        </v-card>
                    </v-col>
                    <v-col md="4">
                        <v-card outlined elevation="0" class="ml-md-1">
                            <h4 class="font-weight-light primary--text px-2">Precio Mensual</h4>
                            <v-divider class="mx-2"></v-divider>
                            <v-text-field
                                type="number"
                                dense
                                placeholder="0"
                                :error-messages="editingInstallment.month_price < 0 ? 'Valor no válido' : ''"
                                v-model="editingInstallment.month_price"
                                class="px-2 pt-4"
                            ></v-text-field>
                        </v-card>
                    </v-col>
                    <v-col md="4">
                        <v-card outlined elevation="0" class="ml-md-1">
                            <h4 class="font-weight-light primary--text px-2">Precio Final</h4>
                            <v-divider class="mx-2"></v-divider>
                            <v-text-field
                                type="number"
                                dense
                                placeholder="0"
                                :error-messages="editingInstallment.final_price < 0 ? 'Valor no válido' : ''"
                                v-model="editingInstallment.final_price"
                                class="px-2 pt-4"
                            ></v-text-field>
                        </v-card>
                    </v-col>
                </v-row>
                <v-card v-if="installmentFormType!='OFFER_CONFIGURATOR'" outlined elevation="0" class="my-1">
                    <h4 class="primary--text font-weight-light px-2">terminal</h4>
                    <v-divider class="mx-2"></v-divider>
                    <v-text-field
                        dense
                        disabled
                        label="final_price"
                        v-model="editingInstallment.terminal__name"
                        class="px-2 pt-4"
                    ></v-text-field>
                </v-card>
                <v-card v-if="installmentFormType!='OFFER_CONFIGURATOR'" outlined elevation="0" class="my-1">
                    <h4 class="primary--text font-weight-light px-2">tarifa</h4>
                    <v-divider class="mx-2"></v-divider>
                    <v-autocomplete
                        class="px-2"
                        clearable
                        multiple
                        hide-selected
                        return-object
                        :items="tariffAdditionalOps"
                        v-model="auxTariffs"
                        item-text="name"
                        item-value="id"
                        label="Tarifa"
                    >
                        <template #selection="{ item }">
                            <v-chip
                                small
                                color="yellow darken-2"
                                class="white--text"
                            >
                                {{ item.name }}
                                <v-icon right> mdi-ticket </v-icon>
                            </v-chip>
                        </template>
                        <template #item="{ item }">
                            <v-row>
                                <v-col cols="7">
                                    {{
                                        item && item.name ? item.name : item.id
                                    }}
                                </v-col>
                                <v-col cols="4">
                                    {{
                                        item && item.operator
                                            ? item.operator
                                            : ''
                                    }}
                                </v-col>
                                <v-col cols="1" class="d-flex justify-center">
                                    <v-icon
                                        :color="
                                            item.is_active ? 'green' : 'red'
                                        "
                                    >
                                        mdi-circle
                                    </v-icon>
                                </v-col>
                            </v-row>
                        </template>
                    </v-autocomplete>
                </v-card>
                <v-card v-if="installmentFormType!='OFFER_CONFIGURATOR'" outlined elevation="0" class="my-1">
                    <h4 class="primary--text font-weight-light px-2">installment_type</h4>
                    <v-divider class="mx-2"></v-divider>
                    <v-autocomplete
                        class="px-2 pt-4"
                        clearable
                        dense
                        hide-selected
                        :items="[
                            'PREPAGO',
                            'ALTA_NUEVA',
                            'PORTABILIDAD',
                            'RENUEVO',
                        ]"
                        v-model="editingInstallment.installment_type"
                        label="Tipo de Installment"
                    >
                        <template #selection="{ item }">
                            <v-chip
                                small
                                color="purple"
                                class="my-1 white--text"
                            >
                                {{ item }}
                                <v-icon right color="white">
                                    mdi-format-list-bulleted-type
                                </v-icon>
                            </v-chip>
                        </template>
                    </v-autocomplete>
                </v-card>
                <v-card v-if="installmentFormType!='OFFER_CONFIGURATOR'" outlined elevation="0" class="my-1">
                    <h4 class="primary--text font-weight-light px-2">created_on</h4>
                    <v-divider class="mx-2"></v-divider>
                    <v-text-field
                        label="created_on"
                        disabled
                        v-model="editingInstallment.created_on"
                        class="px-2"
                    ></v-text-field>
                </v-card>
                <v-card v-if="installmentFormType!='OFFER_CONFIGURATOR'" outlined elevation="0" class="my-1">
                    <h4 class="primary--text font-weight-light px-2">updated_on</h4>
                    <v-divider class="mx-2"></v-divider>
                    <v-text-field
                        label="updated_on"
                        disabled
                        v-model="editingInstallment.updated_on"
                        class="px-2"
                    ></v-text-field>
                </v-card>
            </v-card>
            <v-card-actions elevation="0">
                <v-btn text color="red" @click="isOpenEditDialog = false"
                    >Cerrar</v-btn
                >
                <v-spacer></v-spacer>
                <v-btn depressed :disabled="gtZeroInstallment()" color="success" @click="saveOrUpdateInstallment()"
                    >Guardar</v-btn
                >
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
// He hecho cosas como pa poder crear un installment a cualquier dispositivo... No hacia falta pero hecho está por aqui
import { mapState, mapGetters, mapActions } from 'vuex';
import defaultInstallmentForm from '@/util/management/defaultInstallmentForm.js';
import { clone } from '@/util/libUtil.js';

export default {
    data: () => ({
        searchInstallments: null,
        availableTariffs: [],
        auxTariffs: null,
        auxDevice: null,
    }),
    computed: {
        editingInstallment: {
            get() {
                return this.$store.state.deviceManagement.currentInstallment
                    .form;
            },
            set(val) {
                this.$store.commit('deviceManagement/editingInstallment', val);
            },
        },
        isOpenEditDialog: {
            get() {
                let state =
                    this.$store.state.deviceManagement.currentInstallment
                        .isOpenEditDialog;

                if (this.installmentFormType == 'EDIT') {
                    this.auxTariff = this.editingInstallment.object_id;
                    this.auxDevice = this.editingInstallment.terminal__id;
                }

                if (this.installmentFormType == 'CREATE') {
                    this.auxTariff = this.editingInstallment.object_id;
                    this.auxDevice = this.editingInstallment.terminal__id;
                }

                return state;
            },
            set(val) {
                this.$store.commit(
                    'deviceManagement/isOpenEditInstallmentDialog',
                    val
                );
            },
        },
        ...mapState('deviceManagement', {
            tariffAdditionalOps: (state) => state.tariffAdditionalOps,
            installment: (state) => state.installment,
            devicesDropDown: (state) => state.devicesDropDown,
            installmentFormType: (state) => state.currentInstallment.formType,
        }),
    },
    methods: {
        gtZeroInstallment(){
            return (this.editingInstallment.initial_price <= 0)
                && (this.editingInstallment.month_price <= 0)
                && (this.editingInstallment.final_price <= 0)
        },
        setDeviceToObj() {
            let device = this.devicesDropDown.find(
                (device) => device.id == this.auxDevice
            );

            this.editingInstallment.terminal__name = device['name'];
            this.editingInstallment.terminal__id = device['id'];
        },
        saveOrUpdateInstallment() {
            if (this.installmentFormType == 'CREATE') {
                this.auxTariffs.forEach((element) => {
                    this.editingInstallment.tariff_name = element.name;
                    this.editingInstallment.object_id = element.id;
                    this.createInstallment();
                });
            }
            else if (this.installmentFormType == 'OFFER_CONFIGURATOR') {
                let tariff = this.auxTariffs[0]
                let installment = this.editingInstallment.installment_type

                this.editingInstallment.tariff_name = this.auxTariffs[0].name;
                this.editingInstallment.object_id = this.auxTariffs[0].id;

                this.createInstallment().then((resp) => {
                    this.$store.dispatch('configuradorOferta/getInstallments', {
                            installment_type: installment,
                            tarifa: tariff
                        }
                    )
                })
            }
            else
                this.auxTariffs.forEach((element) => {
                    this.editingInstallment.tariff_name = element.name;
                    this.editingInstallment.object_id = element.id;
                    this.updateInstallment();
                });

            this.editingInstallment = clone(defaultInstallmentForm)
            this.isOpenEditDialog = false
        },
        ...mapActions('deviceManagement', [
            'updateInstallment',
            'createInstallment',
        ]),
    },
    watch: {
        editingInstallment() {
            this.auxTariffs = this.tariffAdditionalOps.filter(
                (item) => item.id == this.editingInstallment.object_id
            );
        },
    },
    beforeCreate() {
        if (this.$store.state.deviceManagement.tariffAdditionalOps.length == 0)
            this.$store.dispatch('deviceManagement/getTariffAdditionalOps');
    },
};
</script>   